<template>
    <v-navigation-drawer app absolute permanent left class="background" height="100%" :width="$vuetify.breakpoint.mdAndUp ? 180 : 70">
        <img :class="$vuetify.breakpoint.mdAndUp ? 'ml-6 mr-8 mt-2 mb-12' : 'ml-1 mr-1 mt-2 mb-12'" :src="require('@/assets/DigiWheel_Logo_Evolution_Company_RGB_Yellow_Black.svg')" alt="logo">

        <v-list dense nav class="mb-4">
            <v-list-item
                v-for="item in items"
                :key="item.title"
                link
                @click="goToPage(item.path)"
            >
              <v-list-item-icon :class="$vuetify.breakpoint.mdAndUp ? 'mx-4 background--text' : 'mx-2 background--text'">
                  <img v-if="item.image" :src="require(`@/assets/${item.image}`)" :style="{ width: '24px', height: '24px' }" />
                  <v-icon v-else>{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content v-if="$vuetify.breakpoint.mdAndUp">
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
      </v-list>

    </v-navigation-drawer>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: "NavigationDrawer",
    computed: {
      ...mapGetters(['getUser']),
      isAdmin() {
        return this.getUser && this.getUser.name === 'admin';
      },
      items() {
        const baseItems = [
          { title: 'Games', image: 'wheel.png', path: '/'},
          { title: 'Game Rules', icon: 'mdi-clipboard-edit-outline', path: '/gamerules' },
          { title: 'Asset Library', icon: 'mdi-image-outline', path: '/assets' },
          // { title: 'Templates', icon: 'mdi-text-box-outline', path: '' },
          // { title: 'Demo Wheels', icon: 'mdi-web', path: '' },
        ];
        
        if (this.isAdmin) {
          baseItems.push({ title: 'Admin', icon: 'mdi-account-cog', path: '/admin' });
        }
        
        return baseItems;
      }
    },
    data () {
      return {
        right: null,
      }
    },
    methods: {
      goToPage(path) {
        const currentPath = this.$route.path;
        if (currentPath === path) return;
        
        window.location.assign(this.$router.resolve({ path: path }).href);
      }
    }
  }

  
</script>
